import { VFlow } from 'bold-ui'
import { useState } from 'react'
import { IdadeGestacionalAcompanhamentoPreNatal } from 'view/atendimentos/detail/soap/aside/pre-natal/model-acompanhamentoPreNatal'
import { DiscussaoCasoPageContent } from 'view/cuidados-compartilhados/components/DiscussaoCasoPageContent'
import {
  CidadaoCuidadoCompartilhado,
  CuidadoCompartilhadoModel,
  CuidadoCompartilhadoVideochamadaState,
  DiscussaoCasoFormModel,
  ResponsavelCuidadoCompartilhado,
} from 'view/cuidados-compartilhados/model-cuidadoCompartilhado'

import { CuidadoCompartilhadoPanel } from '../components/CuidadoCompartilhadoPanel'
import { DiscussaoCasoForm } from './DiscussaoCasoForm'

interface DiscussaoCasoViewProps {
  cuidadoCompartilhado: CuidadoCompartilhadoModel
  cidadao: CidadaoCuidadoCompartilhado
  headerRef: React.RefObject<HTMLDivElement>
  responsavelCuidado: ResponsavelCuidadoCompartilhado
  cacheState: DiscussaoCasoFormModel
  videochamadaUuidState: CuidadoCompartilhadoVideochamadaState
  idadeGestacional?: IdadeGestacionalAcompanhamentoPreNatal
  updateCacheState: (values: DiscussaoCasoFormModel) => void
  handleSubmit: (values: DiscussaoCasoFormModel) => Promise<void>
  handleCancel: () => void
}

export const DiscussaoCasoView = (props: DiscussaoCasoViewProps) => {
  const {
    cuidadoCompartilhado,
    cidadao,
    headerRef,
    responsavelCuidado,
    cacheState,
    videochamadaUuidState,
    idadeGestacional,
    updateCacheState,
    handleCancel,
    handleSubmit,
  } = props

  const [initialValues] = useState(cacheState) // usado pra setar os valores iniciais do Form apenas na primeira vez que renderizar

  return (
    <DiscussaoCasoPageContent
      cidadao={cidadao}
      headerRef={headerRef}
      idadeGestacional={idadeGestacional}
      cuidadoCompartilhadoId={cuidadoCompartilhado.id}
      isDiscutirCaso
    >
      <VFlow>
        <CuidadoCompartilhadoPanel cuidadoCompartilhado={cuidadoCompartilhado} />

        <DiscussaoCasoForm
          cuidadoCompartilhado={cuidadoCompartilhado}
          responsavelCuidado={responsavelCuidado}
          initialValues={initialValues}
          videochamadaUuidState={videochamadaUuidState}
          updateCacheState={updateCacheState}
          handleSubmit={handleSubmit}
          handleCancel={handleCancel}
        />
      </VFlow>
    </DiscussaoCasoPageContent>
  )
}
